/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Group, Namespace, useTranslate } from "localization";
import { Button, Modal } from "minimum-ui/core";
import { SubmissionSlotData } from "types/SubmissionSlots";
import { StatusModal } from "ui/core";

import { RequestTaskUpdate } from "API/Endpoints/Tasks/payloads";

import { useSubmitModal } from "./useSubmitModal";

export const SubmitModal: React.FC<{
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  onFailure: (e: any) => void;
  submitAction: () => Promise<
    RequestTaskUpdate | SubmissionSlotData | null
  > | void;
  onSuccessText: string;
  description?: string;
  confirmationText?: string;
  title?: string;
  onSuccessTitle?: string;
}> = ({
  open,
  onClose,
  submitAction,
  onSuccess,
  onFailure,
  onSuccessText,
  description,
  confirmationText,
  title,
  onSuccessTitle,
}) => {
  const { translate } = useTranslate(Namespace.DEFAULT, Group.SUBMIT_MODAL);

  const { submissionSuccess, loading, handleSubmit } = useSubmitModal({
    submitAction,
    onFailure,
    onClose,
  });

  if (submissionSuccess) {
    return (
      <StatusModal
        onDismiss={onSuccess}
        isOpen={true}
        title={onSuccessTitle || translate("success")}
        content={description}
        actions={<Button onClick={onSuccess}>{onSuccessText}</Button>}
        noBorder
      />
    );
  }
  return (
    <Modal
      isOpen={open}
      onDismiss={onClose}
      title={title || translate("title")}
      content={confirmationText || translate("content")}
      noBorder
      actions={
        <>
          <Button variant="text" onClick={onClose}>
            {translate("no", { namespace: Namespace.DEFAULT })}
          </Button>
          <Button loading={loading} onClick={handleSubmit}>
            {translate("yes", { namespace: Namespace.DEFAULT })}
          </Button>
        </>
      }
    />
  );
};
